module.exports = __webpack_public_path__ + "images/emoji/racehorse.ce4e104e239c69290c3f.png";